import React from "react";

import { useRedirectToCertification } from '../../utils/redirect';
import StaticLayout from "./StaticLayout";

export default function ProgramPage() {
  useRedirectToCertification("benefits");
  return (
    <StaticLayout>
      <div className="section horizontal-page-title">
        <div className="container">
          <div className="content-row">
            <div className="content-row-contents">
              <div className="badge badge-title text-primary-2" />
              <h1 className="heading-3">Program Benefits</h1>
            </div>
            <div className="justify-center page-title-text">
              <div className="content-row-contents" />
            </div>
          </div>
        </div>
        <div className="decoration-container">
          <img
            src="/landing-page/images/grid-dark.svg"
            alt=""
            className="decoration-grid"
          />
          <div
            data-w-id="35f9b2b5-6f2e-bcc0-b419-0ce254d19861"
            className="decoration-circle bg-primary-3"
          />
        </div>
      </div>

      <div className="">
        <div className="container">
          <div className="section-title">
            <div className="badge badge-title text-white" />
            <div className="text-large">
              <p>
                Our Black-owned business certification is a pathway to new
                opportunities. Providing our reviewer team the data points we
                need to certify your company establishes you as a trusted vendor
                and potential partner.
              </p>
              <p>
                Our partners at the United States Black Chambers Inc. (USBC)
                receive daily requests from local & federal government agencies,
                corporate partners, and everyday consumers who want to spend
                money with Black businesses they can trust. We source directly
                from the certified enterprises in this database to support those
                conversations and facilitate meaningful relationships that
                create revenue.
              </p>
              {/* <p>
                                We believe every business, whether they are a bakery, barbershop, or bank, deserves legitimate channels for growth. Because of that, <b>we offer our Black-owned business certification completely free</b> sign up and use.
                            </p> */}

              {/* <h6>So what does this look like for your business?</h6> */}
            </div>
          </div>
        </div>
      </div>

      <div className="block-section container cert-container align-items-center mt-30">
        <div className="block-section-60 font-weight-bold hero">
          <div className=" h6-small-4">About ByBlack Badge</div>
          <p className="p-small-1">
            The ByBlack Badge is the official seal designating a business as
            Black-Owned and Operated. It is awarded by the U.S. Black Chambers,
            Inc. & ByBlack.us Platform. Once awarded, your business can feature
            this badge in marketing communications, email signature lines,
            websites, print materials, and social media posts.
          </p>
        </div>

        <div className="block-section-35" style={{ margin: "auto" }}>
          <img
            style={{ maxWidth: 350 }}
            src="/assets/images/programs/badge.png"
            alt=""
          />
        </div>
      </div>

      <div className="block-section container cert-container align-items-center reverse-flex mt-30">
        <div className="block-section-35-left text-left mx-auto">
          <img
            style={{ maxWidth: 350 }}
            src="/assets/images/programs/certificate.png"
            alt=""
          />
        </div>

        <div className="block-section-60 font-weight-bold hero">
          <div className=" h6-small-4">About ByBlack Certificate</div>
          <p className="p-small-1">
            Upon certification, you will receive an approval email. We will
            generate a unique digital certificate specific to your business.
            You’re welcome to download or print a copy for your records. You are
            welcome to use it in discussions of potential contracting
            opportunities.
          </p>
        </div>
      </div>

      <div className="block-section container cert-container align-items-center mt-30">
        <div className="block-section-60 font-weight-bold hero">
          <div className=" h6-small-4">Educational Opportunities</div>
          <p className="p-small-1">
            Certified Black-owned businesses receive free access to major USBC
            events and national conferences. We also work with companies and
            government partners to create specialized skills building, seminars,
            and training that will help you navigate the ever-changing economic
            landscape.
          </p>
        </div>

        <div className="block-section-35" style={{ margin: "auto" }}>
          <img
            style={{ maxWidth: 350 }}
            src="/assets/images/programs/rect1.png"
            alt=""
          />
        </div>
      </div>

      <div className="block-section container cert-container align-items-center reverse-flex mt-30">
        <div className="block-section-35-left text-left mx-auto">
          <img
            style={{ maxWidth: 350 }}
            src="/assets/images/programs/rect2.png"
            alt=""
          />
        </div>

        <div className="block-section-60 font-weight-bold hero">
          <div className=" h6-small-4">Grants & Potential Funding Programs</div>
          <p className="p-small-1">
            The USBC helped give away almost $5 million in grants to businesses
            in 2020. We expect local chambers, corporate sponsors, and the USBC
            to give away even more in-kind funds, economic support, and business
            opportunities in the year to come. Becoming certified enables us to
            help ensure your business has access to these opportunities when and
            where they’re happening.
          </p>
        </div>
      </div>

      <div className="block-section container cert-container align-items-center mt-30">
        <div className="block-section-60 font-weight-bold hero">
          <div className=" h6-small-4">
            Local & National Relationship Building
          </div>
          <p className="p-small-1">
            When business owners join our community, they receive access to
            local chambers of commerce in their neighborhood as well as a
            champion in Washington DC through the USBC. To demonstrate the
            potential of this opportunity, the USBC even hosted a discussion
            with Vice President Kamala Harris and Secretary of Treasury Janet
            Yellen, where Black business owners got to share their priorities
            for an economic recovery. We want to ensure every business owner has
            access to rooms like that through tools like this.
          </p>
        </div>

        <div className="block-section-35" style={{ margin: "auto" }}>
          <img
            style={{ maxWidth: 350 }}
            src="/assets/images/programs/rect3.png"
            alt=""
          />
        </div>
      </div>

      <div className="block-section container cert-container align-items-center reverse-flex mt-30">
        <div className="block-section-35-left text-left mx-auto">
          <img
            style={{ maxWidth: 350 }}
            src="/assets/images/programs/rect4.png"
            alt=""
          />
        </div>

        <div className="block-section-60 font-weight-bold hero">
          <div className=" h6-small-4">
            Corporate Sponsored Matchmaking Events
          </div>
          <p className="p-small-1">
            We work with the world's largest companies to help diversify their
            supply chains and make more inclusive choices when it comes to
            potential vendors for products or services. That could be anything
            from catering an event, subcontracting part of a project, or
            providing products in their stores.
          </p>
        </div>
      </div>

      <div className="block-section container align-items-center text-center mt-30">
        <div className="h5-small-1">
          We think more Black businesses deserve a seat at the decision-making
          tables of corporate America. We didn't think it was enough to just
          bring more chairs, so we decided to build a platform. If that
          sentiment resonates. Join our movement and certify your business here
          today
        </div>
      </div>

      <div className="section-large">
        <div className="container">
          <div className="cta-container">
            <h3 className="medium-heading-2 ">Have more questions?</h3>
            <p className="h5-small-1">
              You can reach out to our team to learn more here.
            </p>
            <div className="cta-action-container" style={{ marginTop: 20 }}>
              <a
                href="mailto:certification@byblack.us"
                className="button w-button"
              >
                Get in touch
              </a>
            </div>
          </div>
        </div>
        <div className="decoration-container left">
          <div className="decoration-circle bg-primary-3" />
        </div>
      </div>
    </StaticLayout>
  );
}
